import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbNav } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { AppFormsService } from "../../forms/app-forms.service";
import { EmailConfirmStatus, Stage } from "../../shared/services/forge-rock.interface";
import { ForgeRockService } from "../../shared/services/forge-rock.service";
import { UserService } from "../../shared/services/user.service";
import { AbstractJourneyComponent } from "./abstract-journey.component";

@Component({
  selector: 'abstract-registration-journey',
  templateUrl: './abstract-journey.component.html'
})
export abstract class AbstractRegistrationJourneyComponent extends AbstractJourneyComponent {

  active !: string | undefined;
  customClasses:string[] = [];
  focusemail = false;
  focusIdentity = false;
  registered = false; 
  sentVerificattionCode = false;
  translationData:any = {}  
  showSpinner = false;
  journeyStarted = false;
  @ViewChild('nav', { static: true }) nav !: NgbNav;

  abstract getNextNavStep(stage ?:Stage): { stage: Stage } | undefined;
  abstract unlockedStage(stage:Stage): boolean;

  constructor(
    protected override router: Router, 
    protected override route:ActivatedRoute,
    protected override FRService: ForgeRockService,
    protected override userService: UserService,
    private translate: TranslateService,
    private formsService: AppFormsService
)  {
    super(FRService,router,route,userService);
  }

  override getTreeName(): string {
    return 'registration';
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showSpinner = true;
  }

  override ngAfterViewInit():void {
    super.ngAfterViewInit();
    this.nav?.shown.subscribe((activeStep) => {
      this.focusemail = (activeStep == Stage.VERIFIED_EMAIL.toString()) ;
      this.focusIdentity = (activeStep == Stage.USER_IDENTITY.toString())
    })

   let subscribe = this.OnJourneyStarted.subscribe((val)=>{
    this.journeyStarted = true;
    if (this.nextStage == Stage.LOGIN) {
      this.confirmSuccess(this.sentVerificattionCode ? EmailConfirmStatus.VERIFICATION_CODE_SENT: EmailConfirmStatus.REGISTRATION_SUCCESS);
    }
    if (val) {
       this.showSpinner = false;
       let currentStage = this.getNextNavStep()?.stage;
       this.active = currentStage?.toString();
       if (currentStage == Stage.TOU && this.userService.touAccepted) {
        this.hasStepResponse(undefined,currentStage);
       }
       subscribe.unsubscribe();
    }
   });
  }

  hasStepResponse(data:any, currentStage:Stage) {
    // console.log('hasStepResponse', this.unlockedStage(currentStage), ' - currentStage',   currentStage, ' - data', data);
    if (this.unlockedStage(currentStage)) {
        let formdata = [Stage.USER_CREATION, Stage.VERIFIED_EMAIL, Stage.OTP_METHOD, Stage.OTP_RESEND, Stage.OTP].includes(currentStage) ? data : undefined;
        this.nextStageInJourney(formdata).then((nextStage)=>{
          this.onStepComplete(currentStage);
        },(err)=>{

        });
    
    }
  }

  onStepComplete(currentStage:Stage) {
    if (this.hasStepCompleted(currentStage)) {
        this.active = this.getNextNavStep(currentStage)?.stage.toString();
        if (this.registered) {
          if (this.nextStage == Stage.EMAIL_SENT) {
            this.sentVerificattionCode = true;
            this.hasStepResponse({},this.nextStage); //acknowledge message received to IDP
          }else{
            this.confirmSuccess(this.sentVerificattionCode ? EmailConfirmStatus.VERIFICATION_CODE_SENT: EmailConfirmStatus.REGISTRATION_SUCCESS);
          }
        }
    }
  }
 

  protected hasStepCompleted(stage:Stage) {
    switch (stage) {
      case Stage.TOU: return this.userService.touAccepted;
      case Stage.USER_IDENTITY: return this.userService.identityVerified;
      case Stage.VERIFIED_EMAIL: return this.userService.emailConfirmed;
      case Stage.USER_CREATION: this.registered = this.userService.registered; return this.userService.registered;
      case Stage.EMAIL_SENT: return this.sentVerificattionCode;
    }
    return false;
  }

   protected override showErrors() {
    this.formsService.showErrors(true);
    this._errorControl?.showErrors();
  }

    protected override confirmSuccess(status:EmailConfirmStatus) {
      let url = `${this.userType}/confirm-email`
      this.router.navigate([url],{skipLocationChange:true,
                                  queryParams: {status: status}});
    }
  
}
